import { ROUTES_NAMES } from 'constants/name.routes'
import { EditSector } from 'pages/Configurations/EditSector'
import { FormUser } from 'pages/Configurations/FormUser'
import { Sectors } from 'pages/Configurations/Sectors'
import {
  ConfigsContainer,
  ConfigsWrapper,
  Nav,
  navLinkStyled,
  notStyledNav,
  styledNav,
} from 'pages/Configurations/styles'
import { ConfigurationsUsers } from 'pages/Configurations/Users'
import { useEffect } from 'react'
import { NavLink, useLocation, useNavigate } from 'react-router-dom'
import { Unities } from './Unities'

const Configurations = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (pathname === ROUTES_NAMES.configurationsRoutes.configurations) {
      navigate(ROUTES_NAMES.configurationsRoutes.users)
    }
  }, [pathname])

  const selectedPage = () => {
    switch (pathname) {
      case ROUTES_NAMES.configurationsRoutes.configurationsUsers:
        return <ConfigurationsUsers />
      case ROUTES_NAMES.configurationsRoutes.configurationsSectors:
        return process.env.REACT_APP_PROXY_URL === 'https://localhost:3002' 
          ? <Sectors /> 
          : null
    }
  }

  if (pathname === ROUTES_NAMES.configurationsRoutes.configurationsUnities)
    return <Unities />

  return (
    <ConfigsContainer>
      <ConfigsWrapper>
        {pathname.includes(ROUTES_NAMES.configurationsRoutes.newUser) ||
          pathname.includes(ROUTES_NAMES.configurationsRoutes.accessUser) ? (
          <FormUser />
        ) : pathname.includes('/configuracoes/edicao-setor') ? (
          <EditSector />
        ) : (
          <>
            <Nav>
              <NavLink
                to={ROUTES_NAMES.configurationsRoutes.configurationsUsers}
                className={({ isActive }) =>
                  `${navLinkStyled} ${isActive ? styledNav : ''}`
                }
              >
                Usuários
              </NavLink>

              {process.env.REACT_APP_PROXY_URL === 'https://localhost:3002' && (
                <NavLink
                  to={ROUTES_NAMES.configurationsRoutes.configurationsSectors}
                  className={({ isActive }) =>
                    `${navLinkStyled} ${isActive ? styledNav : notStyledNav}`
                  }
                >
                  Setores
                </NavLink>
              )}
              <NavLink
                to={ROUTES_NAMES.configurationsRoutes.configurationsUnities}
                className={({ isActive }) =>
                  `${navLinkStyled} ${isActive ? styledNav : notStyledNav}`
                }
              >
                Unidades
              </NavLink>
            </Nav>

            {selectedPage()}
          </>
        )}
      </ConfigsWrapper>
    </ConfigsContainer>
  )
}

export { Configurations }

